import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import "@/App.css";
import { LanguageProvider, useLang } from "@/i18n/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function DocumentTitle() {
  const { t, lang } = useLang();
  React.useEffect(() => {
    document.title = t("meta.title");
    document.documentElement.lang = lang === "ec" ? "es-EC" : "en";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", t("meta.description"));
  }, [t, lang]);
  return null;
}

function LangLayout() {
  return (
    <LanguageProvider>
      <DocumentTitle />
      <div className="flex min-h-screen flex-col bg-white text-slate-900 font-body">
        <Header />
        <div className="flex-1">
          <Outlet />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </LanguageProvider>
  );
}

function LangGuard({ children }) {
  // Guard to only allow /ec and /en; anything else redirects to /ec
  const location = useLocation();
  const first = location.pathname.split("/")[1];
  if (first !== "ec" && first !== "en") {
    return <Navigate to="/ec" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ec" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />

        <Route
          path="/:lang"
          element={
            <LangGuard>
              <LangLayout />
            </LangGuard>
          }
        >
          <Route index element={<Home />} />
          <Route path="privacy" element={<LegalPage scope="privacy" />} />
          <Route path="cookies" element={<LegalPage scope="cookies" />} />
          <Route path="terms" element={<LegalPage scope="terms" />} />
          <Route path="*" element={<Navigate to="" replace />} />
        </Route>

        <Route path="*" element={<Navigate to="/ec" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
